<div class="card">
    <div class="card__header">
        <div>
            <p class="title">Reserva de pratos</p>
            <p class="description">CR - {{ reservation.code }} - {{reservation.branchName}}</p>
        </div>
    </div>
    <hr />
    <div style="overflow-x: auto;">
        <div class="card__winner-table" style="min-width: max-content;">
            <div class="card__winner-table__row card__winner-table__row--header"
                [ngStyle]="getColumnTemplate(reservation.columns)">
                <div class="card__winner-table__header" *ngFor="let header of reservation.columns">
                    {{header}}
                </div>
            </div>

            <div class="card__winner-table__row" *ngFor="let dataLine of reservation.dataLines"
                [ngStyle]="getColumnTemplate(reservation.columns)">
                <div class="card__winner-table__cell" *ngFor="let item of dataLine">
                    {{ item }}
                </div>
            </div>
        </div>
    </div>
</div>